<template>
    <main-layout class="bg-gray-100 min-h-screen flex flex-col list-bouteilles">

        <!-- En-tête + CTA + recherche + filtres -->
        <div class="bg-gradient-to-b from-secondary to-primary">
            <div class="p-2 space-y-3">
                <app-header icon="bouteille" class="text-white">
                    <div class="flex items-center justify-between">
                        <h1 class="text-2xl font-semibold tracking-wide">Bouteilles</h1>
                    </div>
                </app-header>

                <action-bar :back="{ name: 'home' }" class="!p-0 !m-0">
                    <router-link id="main-action" to="new-bouteille" @click.prevent="addBouteille"
                        class="inline-flex items-center gap-2 bg-white text-primary text-sm font-medium px-4 py-2 rounded-lg shadow-sm hover:shadow transition">
                        <i class="inline-block h-6 w-6 mask mask-otag bg-primary"></i>
                        <span><strong>Ajouter / Scanner</strong> une bouteille</span>
                    </router-link>
                </action-bar>

                <!-- Barre de recherche seule -->
                <filter-bar @searchBarChanged="updateSearch" :placeholderFilter="'Recherche par code, fluide, otag'"
                    type-history="bouteille" class="block !mb-0" />

                <!-- Rangée unique : 3 filtres + 2 boutons / responsive wrap -->
                <div class="flex flex-wrap items-center gap-2 pb-6">

                    <!-- FF -->
                    <div class="checkbox ff">
                        <input type="checkbox" id="filtertype-ff" v-model="ff" @change="updateTypeBouteille"
                            class="sr-only peer" />
                        <label for="filtertype-ff"
                            class="px-4 py-2 rounded-lg text-sm border flex items-center justify-center text-white cursor-pointer transition border-gaz-ff"
                            :class="ff ? 'bg-gaz-ff' : 'bg-transparent'">
                            <i class="inline-block h-6 w-6 mask mask-snow bg-white mr-2"></i>
                            <span>Fluide frigorigènes</span>
                        </label>
                    </div>

                    <!-- Transfert -->
                    <div class="checkbox tf">
                        <input type="checkbox" id="filtertype-tf" v-model="tf" @change="updateTypeBouteille"
                            class="sr-only peer" />
                        <label for="filtertype-tf"
                            class="px-4 py-2 rounded-lg text-sm border flex items-center justify-center text-white cursor-pointer transition border-gaz-tf"
                            :class="tf ? 'bg-gaz-tf' : 'bg-transparent'">
                            <i class="inline-block h-6 w-6 mask mask-snow bg-white mr-2"></i>
                            <span>Transfert</span>
                        </label>
                    </div>

                    <!-- Récupération -->
                    <div class="checkbox rec">
                        <input type="checkbox" id="filtertype-rec" v-model="rec" @change="updateTypeBouteille"
                            class="sr-only peer" />
                        <label for="filtertype-rec"
                            class="px-4 py-2 rounded-lg text-sm border flex items-center justify-center text-white cursor-pointer transition border-gaz-rec"
                            :class="rec ? 'bg-gaz-rec' : 'bg-transparent'">
                            <i class="inline-block h-6 w-6 mask mask-snow bg-white mr-2"></i>
                            <span>Récupération</span>
                        </label>
                    </div>

                    <!-- Bouton Bouteilles actives -->
                    <button type="button" @click="toggleFilterStatus"
                        class="inline-flex items-center justify-center gap-2 h-11 px-4 rounded-lg text-sm font-medium whitespace-nowrap transition select-non "
                        :class="filterActive ? 'bg-bleu-clair text-gray-700' : 'bg-transparent border border-bleu-clair text-white'"
                        style="line-height: 18px;">
                        <i class="inline-block h-5 w-5 mask mask-tools" :class="filterActive ? 'bg-gray-600' : 'bg-white'"></i>
                        Bouteilles actives
                    </button>

                    <!-- Bouton Mes bouteilles -->
                    <button type="button" @click="toggleShowMine"
                        class="inline-flex items-center justify-center gap-2 h-11 px-4 rounded-lg text-sm font-medium whitespace-nowrap transition select-none text-white"
                        :class="showMine ? 'bg-yellow-400' : 'border-yellow-400 border'"
                        style="line-height: 18px;">
                        <i class="inline-block h-5 w-5 mask mask-star bg-white"></i>
                        Mes bouteilles
                    </button>

                </div>
            </div>
        </div>


        <!-- Contenu principal : listes -->
        <div class="bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-3xl -mt-6 flex-1 shadow-xl pb-28">
            <!-- Liste ACTIVE -->
            <div v-show="listVisible === 'active'" class="mx-1 my-2">
                <div id="bouteilles-item" class="list list-bout rounded-2xl overflow-hidden shadow-2xl">
                    <bouteille-item v-for="bouteille in filteredList" :key="bouteille.id" :bouteille="bouteille" :info="bouteilleInfoMap[bouteille.id] || null"
                        class="block odd:bg-white even:bg-[#F7FAFD]" />
                </div>
            </div>

            <!-- Liste INACTIVE -->
            <div v-show="listVisible === 'inactive'" class="mx-1 my-2 ">
                <div id="bouteilles-item-inact"
                    class="list list-bout rounded-2xl overflow-hidden shadow-2xl opacity-95">
                    <bouteille-item v-for="bouteille in filteredListInact" :key="bouteille.id" :bouteille="bouteille" :info="bouteilleInfoMap[bouteille.id] || null"
                        class="block odd:bg-white even:bg-[#F7FAFD]" />
                </div>
            </div>


            <!-- Pagination -->
            <div class="pagination-buttons text-center my-6">
                <button @click="previousPage"
                    v-show="paginator[this.type]['showPreviousButton'] === true && this.strSearch === ''"
                    class="inline-flex items-center justify-center px-3 py-2 rounded-lg text-sm bg-white text-primary shadow-sm hover:shadow transition mr-2">
                    &laquo; précédent
                </button>
                <button @click="nextPage"
                    v-show="paginator[this.type]['showLastButton'] === true && this.strSearch === ''"
                    class="inline-flex items-center justify-center px-3 py-2 rounded-lg text-sm bg-white text-primary shadow-sm hover:shadow transition">
                    suivant &raquo;
                </button>
            </div>
        </div>

    </main-layout>
</template>

<script>
import BouteilleItem from './BouteilleItem.vue'
import Bouteille from '../../js/models/Bouteille'
import OperationBouteille from '../../js/models/OperationBouteille'
import History from "../../js/core/History";
import User from "@/js/models/User";

export default {
  data() {
    return {
      paginator: [
        { lastPage: 1000, currentPage: 1, showPreviousButton: false, showLastButton: true, pageSize: 15 }, // inactives (type 0)
        { lastPage: 1000, currentPage: 1, showPreviousButton: false, showLastButton: true, pageSize: 15 }, // actives (type 1)
      ],
      bottlesActive: [],
      bottlesInactive: [],
      allBouteillesActives: [],
      allBouteillesInactives: [],
      bouteilleInfoMap: {},
      strSearch: '',
      listVisible: 'active', // 'active' | 'inactive'
      ff: true,
      rec: true,
      tf: true,
      type: 1,              // 1 = actives, 0 = inactives (index du paginator)
      // états des boutons sortis de filterBar
      filterActive: true,   // "Bouteilles actives" (true => active, false => inactive)
      showMine: false,      // état du bouton "Mes bouteilles"
      showOnlyMine: false,  // flag utilisé dans la logique de filtrage
    }
  },

  components: { BouteilleItem },

  methods: {
    changeShowMine(val) {
      this.showOnlyMine = val;
      this.filterBouteilles();
    },

    filterBouteilles() {
      if (this.listVisible === "active") {
        if (this.showOnlyMine) {
          this.bottlesActive = _.filter(this.allBouteillesActives, function (bouteille) {
            return bouteille.favori !== null && bouteille.favori.id === this.$user.id;
          }.bind(this));
        } else {
          this.bottlesActive = this.allBouteillesActives;
        }
      } else {
        if (this.showOnlyMine) {
          this.bottlesInactive = _.filter(this.allBouteillesInactives, function (bouteille) {
            return bouteille.favori !== null && bouteille.favori.id === this.$user.id;
          }.bind(this));
        } else {
          this.bottlesInactive = this.allBouteillesInactives;
        }
      }
    },

    toggleFilterStatus() {
      this.filterActive = !this.filterActive;
      this.changeList(this.filterActive);

      // persistance
      History.setHistory('bouteille', {
        text: this.strSearch,
        options: { active: this.filterActive, showMine: this.showMine, ff: this.ff, rec: this.rec, tf: this.tf }
      });
    },

    toggleShowMine() {
      this.showMine = !this.showMine;
      this.changeShowMine(this.showMine);

      History.setHistory('bouteille', {
        text: this.strSearch,
        options: { active: this.filterActive, showMine: this.showMine, ff: this.ff, rec: this.rec, tf: this.tf }
      });
    },

    async fetchBottles() {
      try {
        const data = await Bouteille.getList();

        const bottlesActives = _.filter(data, b => b.actif === true);
        this.bottlesActive = _.sortBy(bottlesActives, ['created_at']).reverse();
        this.allBouteillesActives = this.bottlesActive;

        const bottlesInactives = _.filter(data, b => b.actif === false);
        this.bottlesInactive = _.sortBy(bottlesInactives, ['created_at']).reverse();
        this.allBouteillesInactives = this.bottlesInactive;

        // applique le filtre "mes bouteilles" si actif
        this.filterBouteilles();

        // Lecture unique de listOperations pour calculer isReutilisable sur toutes les bouteilles
        const opObj = new OperationBouteille();
        const allOps = await opObj.getList();
        const infoMap = {};

        for (const bouteille of data) {
          if (bouteille.type !== 'Fluide frigorigène' && bouteille.poids_net !== 0) {
            const boutId = String(bouteille.id).includes('N-') ? bouteille.id : parseInt(bouteille.id);
            const ops = allOps.filter(op => {
              if (op.bouteille && op.bouteille.id === boutId) return true;
              return op.id_bouteille === boutId;
            });

            let reutilisable = false;
            let tempCalc = 0;
            for (const op of ops) {
              const idType = parseInt(op.id_type);
              if (idType === 1 || idType === 2 || idType === 3 || idType === 6) {
                tempCalc = round(tempCalc - op.quantite, 3);
              } else {
                tempCalc = round(tempCalc + op.quantite, 3);
              }
              if (op.type && op.type.includes('réutilisation')) {
                reutilisable = true;
              }
              if (tempCalc === bouteille.poids_net) break;
            }
            infoMap[bouteille.id] = reutilisable ? 'Recyclé' : 'Déchets';
          }
        }

        this.bouteilleInfoMap = infoMap;
      } catch (e) {
        // silent
      }
    },

    addBouteille() {
      Bouteille.askAddBouteille()
    },

    // appelé par <filter-bar @searchBarChanged="updateSearch">
    updateSearch([text]) {
      this.strSearch = String(text || '').toLowerCase();

      History.setHistory('bouteille', {
        text: this.strSearch,
        options: { active: this.filterActive, showMine: this.showMine, ff: this.ff, rec: this.rec, tf: this.tf }
      });
    },

    changeList(filter) {
      if (filter === false) {
        this.listVisible = 'inactive';
        this.type = 0;
      } else {
        this.listVisible = 'active';
        this.type = 1;
      }
      this.filterBouteilles();
    },

    nextPage() {
      if (this.paginator[this.type]['currentPage'] < this.paginator[this.type]['lastPage']) {
        this.paginator[this.type]['currentPage']++;
      }
      this.updateButton();
    },

    previousPage() {
      if (this.paginator[this.type]['currentPage'] > 1) {
        this.paginator[this.type]['currentPage']--;
      }
      this.updateButton();
    },

    updateButton() {
      this.paginator[this.type]['showPreviousButton'] = this.paginator[this.type]['currentPage'] !== 1;
      this.paginator[this.type]['showLastButton'] = this.paginator[this.type]['currentPage'] !== this.paginator[this.type]['lastPage'];
      if (this.paginator[this.type]['lastPage'] === 0) {
        this.paginator[this.type]['showLastButton'] = false;
      }
      window.scrollTo(0, 0);
    },

    slicedItems(bottles) {
      if (this.strSearch !== '') {
        return bottles; // en recherche on affiche tout (pas de pagination)
      }
      return bottles.slice(
        (this.paginator[this.type]['currentPage'] - 1) * this.paginator[this.type]['pageSize'],
        this.paginator[this.type]['currentPage'] * this.paginator[this.type]['pageSize']
      );
    },

    async updateTypeBouteille() {
      // Persiste l’état des 3 filtres type
      await History.setHistory('bouteille', {
        text: this.strSearch,
        options: { ff: this.ff, rec: this.rec, tf: this.tf, active: this.filterActive, showMine: this.showMine }
      });
      // les computed se recalculent automatiquement
    }
  },

  async mounted() {
    // restauration de l’historique
    const history = await History.getHistory('bouteille');

    if (history) {
      if (typeof history.text !== 'undefined') {
        this.strSearch = String(history.text || '').toLowerCase();
      }
      if (history.options) {
        if (typeof history.options.ff !== 'undefined') this.ff = !!history.options.ff;
        if (typeof history.options.rec !== 'undefined') this.rec = !!history.options.rec;
        if (typeof history.options.tf !== 'undefined') this.tf = !!history.options.tf;
        if (typeof history.options.active !== 'undefined') this.filterActive = !!history.options.active;
        if (typeof history.options.showMine !== 'undefined') this.showMine = !!history.options.showMine;
      }
      // applique l’état restauré
      this.changeList(this.filterActive);
      this.changeShowMine(this.showMine);
    }

    this.fetchBottles();
  },

  computed: {
      filteredList() {
          let search = this.strSearch;
          let types = [];
          this.updateButton()

          if (this.ff) {
              types.push('Fluide frigorigène')
          }
          if (this.rec) {
              types.push('Récupération')
          }
          if (this.tf) {
              types.push('Transfert')
          }

          let listBottles = this.bottlesActive.filter(bouteille => {

              let check = false;
              if (bouteille.nom && bouteille.nom.nom.toLowerCase().includes(search)) {
                  check = true
              }

              if (bouteille.otag && bouteille.otag.includes(search)) {
                  check = true
              }

              if (bouteille.fournisseur && bouteille.fournisseur.nom.toLowerCase().includes(search)) {
                  check = true
              }

              if (_.has(bouteille, 'fluide') && bouteille.fluide !== null && bouteille.fluide.nom.toLowerCase().includes(search)) {
                  check = true
              }

              if (bouteille.code.toLowerCase().includes(search)) {
                  check = true
              }

              if (_.has(bouteille, 'type') && types.indexOf(bouteille.type) === -1) {
                  check = false
              }

              if (bouteille.restitution === true) {
                  check = false
              }

              if (bouteille.actif === false) {
                  check = false;
              }

              if (check) {
                  return bouteille
              }
          })

          this.paginator[1]['lastPage'] = Math.ceil(listBottles.length / this.paginator[1]['pageSize']);
          if (this.paginator[1]['lastPage'] < this.paginator[1]['currentPage']) {
              this.paginator[1]['currentPage'] = 1;
          }
          this.updateButton();
          return this.slicedItems(listBottles);

      },

      filteredListInact() {

          let search = this.strSearch;
          let types = [];
          this.updateButton()


          if (this.ff) {
              types.push('Fluide frigorigène')
          }
          if (this.rec) {
              types.push('Récupération')
          }
          if (this.tf) {
              types.push('Transfert')
          }

          let listBottles = this.bottlesInactive.filter(bouteille => {
              let check = false;
              if (bouteille.nom && bouteille.nom.nom.toLowerCase().includes(search)) {
                  check = true
              }

              if (bouteille.otag && bouteille.otag.includes(search)) {
                  check = true
              }

              if (bouteille.fournisseur && bouteille.fournisseur.nom.toLowerCase().includes(search)) {
                  check = true
              }

              if (_.has(bouteille, 'fluide') && bouteille.fluide !== null && bouteille.fluide.nom.toLowerCase().includes(search)) {
                  check = true
              }

              if (bouteille.code.toLowerCase().includes(search)) {
                  check = true
              }

              if (_.has(bouteille, 'type') && types.indexOf(bouteille.type) === -1) {
                  check = false
              }

              if (bouteille.restitution === true) {
                  check = false
              }

              if (bouteille.actif === true) {
                  check = false;
              }

              if (check) {
                  return bouteille
              }
          })



          this.paginator[0]['lastPage'] = Math.ceil(listBottles.length / this.paginator[0]['pageSize']);
          if (this.paginator[0]['lastPage'] < this.paginator[0]['currentPage']) {
              this.paginator[0]['currentPage'] = 1;
          }
          return this.slicedItems(listBottles);


      }

  }
}
</script>

<style>
#main-action .icon-otag {
    right: 5px;
    top: 50%;
    margin-top: -17px;
    font-size: 3rem;
}
</style>



// WEBPACK FOOTER //
// ListeBouteilles.vue?762e1654